import { CommonModule, registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppRoutingModule } from './app-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MdePopoverModule } from '@material-extended/mde';
import { LoiHelptextIconModule, LoiHttpClientModule, LoiLoadingModule, GoogleTagManagerServiceModule, LoiBackLinkComponent, LoiBackLinkModule } from 'loi-lti-common';
import { TranslationModule } from './services/translation.service';
import { ModuleDetailsComponent } from './module.details/module.details.component';
import { ModulePartsComponent } from './module.parts/module.parts.component';
import { ActivateModuleDialogComponent } from './activate.module.dialog/activate.module.dialog.component';

import localeNl from '@angular/common/locales/nl';
import { CustomRequestOptions } from './utils/custom-request-options';
import { SettingsService } from './services/settings.service';

registerLocaleData(localeNl);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ModuleDetailsComponent,
    ModulePartsComponent,
    ActivateModuleDialogComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    FlexLayoutModule,
    FormsModule,
    AppRoutingModule,
    TranslationModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatToolbarModule,
    MatDialogModule,
    MatCheckboxModule,
    MdePopoverModule,
    MatButtonModule,
    MatExpansionModule,
    LoiHelptextIconModule,
    LoiLoadingModule,
    LoiHttpClientModule,
    GoogleTagManagerServiceModule,
    LoiBackLinkModule
  ],
  providers: [
    CustomRequestOptions,
    {
      provide: APP_INITIALIZER,
      useFactory: (settingsService: SettingsService) => () => settingsService.getSettingsPromise(),
      deps: [SettingsService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (settingsService: SettingsService) => () => settingsService.getSettingsPromise(),
      deps: [SettingsService],
      multi: true
    },
    {
      provide: 'GTM_ID',
      useFactory: (settingsService: SettingsService) => settingsService.getGoogleTagManagerId(),
      deps: [SettingsService]
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [ActivateModuleDialogComponent]
})
export class AppModule { }
